import { Infer } from "./infer";
import { Reorder } from "./reorder";
import { EventProcessor } from "./event";
import type { EventData } from "@/events/types";
import { Init } from "@/datastore/init";
import handleProductList from "@/ui-sdk/ui-script/product-list";
//import handleCartGoals from "@/ui-sdk/ui-script/cart-goals";
//import handleCartInlineBlock from "@/ui-sdk/ui-script/cart-inline-block";

interface UIEvent {
  type: string;
  target: string;
}

class DataProcessor {
  private static processedData: any = {};
  private static currentPageType: string = "";
  private static history: any[] = [];

  private static setupEventSubscriptions() {
    window.helium.events.subscribe({
      func: (data: EventData) => {
        console.log("EVENT TRIGGERED: infer filter");
        this.reorderList({ type: "productList" });
      },
      filters: ["infer filter"],
      key: "inferFilterToReorderList",
    });
    if (!window.helium.brandData.isPro) return;
    window.helium.events.subscribe({
      func: (data: EventData) => {
        console.log("EVENT TRIGGERED: cart update");
        Init.initCart();
        pollForCartGoalsElement();
        pollCartInlineBlock();
      },
      filters: ["cart update"],
      key: "CartUpdateWatcher",
    });
    window.helium.events.subscribe({
      func: (data: EventData) => {
        console.log("EVENT TRIGGERED: product list");
        handleProductList(
          document.querySelector('[data-helium-name="product-list"]'),
        );
      },
      filters: ["product list"],
      key: "productListWatcher",
    });
  }

  static init() {
    this.setupEventSubscriptions();
    // this.setupEventListeners();
  }

  public static processProductEvent = EventProcessor.processProductEvent;
  public static processUIEvent = EventProcessor.processUIEvent;
  public static infer = Infer.inferAll;

  public static handleEvent = EventProcessor.handle;
  public static handleStartIntersecting =
    EventProcessor.handleStartIntersecting;

  private static triggerEvent(props: EventData): void {
    // window.helium.events.notify(props);
  }

  private static triggerAnalyticsEvent(): void {
    console.log("Triggering analytics event");
    // TODO: Send analytics events
  }

  public static reorderList = Reorder.reorder;
}

export default DataProcessor;

function pollForCartGoalsElement(attempts = 0, maxAttempts = 10) {
  const element = document.querySelector<HTMLElement>(
    '[data-helium-name="cart-goals"]',
  );
  if (element) {
    handleCartGoals(element);
    return;
  } else if (attempts < maxAttempts) {
    setTimeout(() => pollForCartGoalsElement(attempts + 1, maxAttempts), 200);
  } else {
    console.log(
      "Cart goals element not found after maximum attempts. Giving up.",
    );
  }
}

function pollCartInlineBlock(attempts = 0, maxAttempts = 10) {
  const inlineBlockElements = document.querySelectorAll<HTMLElement>(
    '[data-helium-name="cart-inline-block"]',
  );
  if (inlineBlockElements.length > 0) {
    inlineBlockElements.forEach((element) => {
      if (element) {
        const blockType = element.getAttribute(
          "data-helium-cart-inline-block-type",
        );
        console.log(
          `CART INLINE BLOCK ELEMENT FOUND - Type: ${blockType}, Children: ${element.children.length}`,
        );
        handleCartInlineBlock(element);
      }
    });
  } else if (attempts < maxAttempts) {
    setTimeout(() => pollCartInlineBlock(attempts + 1, maxAttempts), 200);
  } else {
    console.log(
      "Cart inline block elements not found after maximum attempts. Giving up.",
    );
  }
}
